import React, { useState } from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { Text } from '../../../CommonComponents/OPL/Text/Text';
import { ClientAccess } from '../../../ClientAccess/ClientAccess';
import { currentClientSelector } from '../../../CommonSelectors/CommonAreaSelector';
import { Button } from '../../../CommonComponents/OPL/Button/Button';
import { WorkflowFooter } from '../WorkflowFooter/WorkflowFooter';
import { Card } from '../../../CommonComponents/OPL/Card/Card';
import { WorkflowComponentProps } from '../../Workflow.meta';
import { WorkflowWrapper } from '../../Workflow.styles';
import { WorkflowIdEnum } from '../../api/useWorkflowDataQuery';
import { OnboardingWorkflow } from '../../../CommonSelectors/CommonArea.types';

const WORKFLOW_ID_MAP: Record<WorkflowIdEnum, OnboardingWorkflow> = {
  [WorkflowIdEnum.Comprehensive]: OnboardingWorkflow.Comprehensive,
  [WorkflowIdEnum.AssetBucketing]: OnboardingWorkflow.AssetBucketingWorkflow,
  [WorkflowIdEnum.EstatePlanning]: OnboardingWorkflow.EstatePlanning,
};

const StyledCard = styled(Card)({
  textAlign: 'center',
  padding: 48,
});

interface Props {
  clientId: string;
  workflowProps: WorkflowComponentProps;
}

export const WorkflowInviteClient: React.FC<Props> = ({ clientId, workflowProps }) => {
  const [isClientAccessModalOpen, setIsClientAccessModalOpen] = useState(false);

  const currentClient: { FirstName: string } | null = useSelector(currentClientSelector);

  if (!currentClient) {
    return null;
  }

  return (
    <>
      <WorkflowWrapper>
        <StyledCard as="main">
          <Text as="h1" fontSize="h4" fontWeight={600} mb="16">
            Would you like to invite {currentClient.FirstName} to complete this wizard?
          </Text>

          <Text as="p" mb="32" mx="48">
            You can have {currentClient.FirstName} log in to the client portal and complete the{' '}
            <Text as="strong" fontWeight={500}>
              Profile
            </Text>{' '}
            section of this wizard. You can also give them access to the financial plan once it is
            completed.
          </Text>

          <Button
            size="large"
            variant="secondary"
            leftIcon="far fa-envelope-open"
            onClick={() => setIsClientAccessModalOpen(true)}
          >
            Invite Client to Orion Planning
          </Button>
        </StyledCard>
      </WorkflowWrapper>

      <WorkflowFooter isFirstStep onNext={workflowProps.onNext} />

      {isClientAccessModalOpen && (
        <ClientAccess
          clientId={clientId}
          onClose={() => setIsClientAccessModalOpen(false)}
          defaultOnboardingWorkflow={WORKFLOW_ID_MAP[workflowProps.workflowId]}
        />
      )}
    </>
  );
};
